var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FieldCustom"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.field.html(_vm.application, this.$store))}})])}
var staticRenderFns = []

export { render, staticRenderFns }